import { cn } from "@/lib/utils";

const WEEKDAYS = [
  { code: "su", label: "Su" },
  { code: "mo", label: "Mo" },
  { code: "tu", label: "Tu" },
  { code: "we", label: "We" },
  { code: "th", label: "Th" },
  { code: "fr", label: "Fr" },
  { code: "sa", label: "Sa" },
] as const;

interface WeekdayToggleProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function WeekdayToggle({ value, onChange, className }: WeekdayToggleProps) {
  const activeDays = new Set(
    value
      .split(",")
      .map((d) => d.trim().toLowerCase())
      .filter(Boolean),
  );

  const toggle = (code: string) => {
    const next = new Set(activeDays);
    if (next.has(code)) {
      next.delete(code);
    } else {
      next.add(code);
    }
    const ordered = WEEKDAYS.map((w) => w.code).filter((c) => next.has(c));
    onChange(ordered.join(","));
  };

  return (
    <div className={cn("flex gap-1.5", className)}>
      {WEEKDAYS.map(({ code, label }) => {
        const active = activeDays.has(code);
        return (
          <button
            key={code}
            type="button"
            onClick={() => toggle(code)}
            className={cn(
              "w-9 h-9 rounded-full text-sm font-semibold",
              "transition-all duration-200 cursor-pointer",
              "hover:scale-110 active:scale-95",
              "shadow-sm",
              active
                ? "bg-app-primary text-white shadow-md"
                : "bg-app-surface-raised text-app-text hover:bg-app-primary/10",
            )}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
